import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  Spinner,
  ModalHeader,
} from '@chakra-ui/react';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorDetails } from '../shared/alert/ErrorDetails';
import { SamplesTable } from '../shared/samples/SamplesTable';
import { transportRequestsApi } from '@texas/api/endpoints/transportRequestApi';
import { useApiRequest } from '@texas/api/hooks/useApiRequest';
import { request } from '@texas/utils/helpers/httpHelpers';
import { SpinnerWithLabel } from '../shared/SpinnerWithLabel';
import { sampleEvents } from '../shared/samples/events';

export function ShipmentSamplesModal({
  transportRequestId,
  onClose,
}: {
  transportRequestId: number;
  onClose: () => void;
}) {
  return (
    <Modal isOpen={true} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <Inner transportRequestId={transportRequestId} />
      </ModalContent>
    </Modal>
  );
}

function Inner({ transportRequestId }: { transportRequestId: number }) {
  const { t } = useTranslation();

  const { data, refetch, loading, error } = useApiResource(
    transportRequestsApi.getSamplesInTransportRequest,
  );

  const {
    request: removeRequest,
    loading: removeRequestLoading,
    error: removeRequestError,
  } = useApiRequest(transportRequestsApi.removeSamples);

  useEffect(() => {
    refetch(transportRequestId);
  }, [refetch, transportRequestId]);

  const removeReq = (id: number) =>
    request(removeRequest, [{ sampleIds: [id] }], () => {
      refetch(transportRequestId);
      sampleEvents.onSampleRemovedFromTransportRequest.dispatch();
    });

  return (
    <>
      <ModalHeader>
        {t('sample.includedIn', { id: transportRequestId })}
      </ModalHeader>
      <ModalBody>
        {error && <ErrorDetails error={error} />}
        {removeRequestError && <ErrorDetails error={removeRequestError} />}
        {loading && <Spinner />}
        {removeRequestLoading && (
          <SpinnerWithLabel label={t('sample.removing')} />
        )}
        {!loading && (
          <SamplesTable
            samples={data ?? []}
            onRemoveFromTransportRequest={(id: number) => removeReq(id)}
            onRemoveLoading={removeRequestLoading}
          />
        )}
      </ModalBody>
    </>
  );
}
